import algoliasearch from "algoliasearch"
import {appEnv} from "../../env"

export class SearchClient {

    static get = () => {
        return algoliasearch(appEnv.ALGOLIA_APPLICATION_ID, appEnv.ALGOLIA_SEARCH_ONLY_API_KEY)
    }

}